import AnaliseCriticaTab from "./AnaliseCriticaTab";

export default AnaliseCriticaTab;